import './Spinner.css';

const Spinner = () => {
  return (
    <div className='wrapper'>
      <div className='loading loader'></div>
    </div>
  )
}

export default Spinner